/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Email = (function () {

    function Email() {

        Monet.UI.Fields.TextField.apply (this, arguments);

        var baseElement = null;

        this.createElement = function () {
            if(!baseElement){
                this.input = document.createElement('input');

                this.input.type = 'text';
                this.input.className = 'emailField';
                this.input.value = this.value;
                this.input.autocomplete = "off";

                if(this.maxSize){
                    this.input.maxLength = this.maxSize;
                }

                baseElement = this.input;
                this.rootEl.appendChild(this.input);
            }

        };

        this.dataIsInvalid = function () {
            if(this.input){
                this.value = this.input.value;
            }
            return !Monet.Validators.isEmail(this.value);
        };

        this.validations = function () {
            if(this.input){
                this.value = this.input.value;
            }

            if (this.dataIsInvalid()) {
                $(this.input).addClass('error');
            } else {
                $(this.input).removeClass('error');
            }

        };

        this.addEventListeners = function () {

            this.input.addEventListener('blur', (function (scope) {

                return function () {
                    scope.validations();
                };

            }(this)));

        };

        this.render = function () {

            this.createElement();
            this.addEventListeners();
            return this.rootEl;

        };

    }

    return Email;

}());